import { API_BASE_URL } from '../Utils/constants';
import { authFetch } from './authFetch';

// El Bearer (renovado, sin `Bearer null`, reintento ante 401) lo pone `authFetch`.
const getHeaders = () => ({
  'Content-Type': 'application/json',
});

export const getUserPreferences = async () => {
  const response = await authFetch(`${API_BASE_URL}/getuserpreferences`, {
    method: 'GET',
    headers: getHeaders(),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.message || 'getUserPreferences failed');
  }

  return data;
};

/** @param {{ onboarding_tour_completed?: boolean, onboarding_tour_skipped?: boolean }} payload */
export const updateUserPreferences = async (payload) => {
  const response = await authFetch(`${API_BASE_URL}/updateuserpreferences`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.message || 'updateUserPreferences failed');
  }

  return data;
};
